import React from 'react';
import {useAsyncError} from "react-router-dom";
import GlobalAlert from "../GlobalAlert";
import {View} from "@aws-amplify/ui-react";

function ErrorBoundary() {
  const error = useAsyncError();

  // Uncaught ReferenceError: path is not defined
  return (
    <View>
      <GlobalAlert
        heading={error.message || 'Si è verificato un errore. La preghiamo di riprovare più tardi.'
      }
        variation="error"
      />
    </View>
  );
}

export default ErrorBoundary;